import { Box, styled } from '@mui/material';

export const Logo = styled('img')({
	width: '120px',
	height: '20px',
});

export const Wrap = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '8px',
});

export const ColumnWrapper = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});
